import React from "react";
import Header from "./template/Header";
import Footer from "./template/Footer";
class Layout extends React.Component {
  render() {
    return (
      <>
        <Header />
        <main>{this.props.children}</main>
        <Footer />
      </>
    );
  }
}
export default Layout;
